module.exports = __webpack_public_path__ + "img/pfeil_rechts.315d432b.svg";